import { render, staticRenderFns } from "./A36.vue?vue&type=template&id=4ecaee41&"
import script from "./A36.vue?vue&type=script&lang=js&"
export * from "./A36.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "A36.vue"
export default component.exports